var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"uik-btn__base uik-dropdown-item__wrapper",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('close')}}},[_c('span',{staticClass:"uik-btn__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }